import { clsx } from "@/src/utils/clsx"

type textElementProps = {
    text: string
    as: "p" | "span"
    className?: string
}

export default function GCTextElement({ text, as, className }: textElementProps) {
    if (!text) return null

    const Tag = as

    const hasLineBreaks = text.includes("\n") || text.includes("\r\n")

    return (
        <Tag className={clsx(className, hasLineBreaks && "whitespace-pre-line")}>
            {text}
        </Tag>
    )
}
